import * as React from 'react';
import { AvatarBase } from './Avatar.base';
import { st, classes } from './Avatar.st.css';
import { AvatarSize } from './types';
/** Avatar is a type of element that visually represents a user, either as an image, placeholder or text (name initials). */
export class Avatar extends React.Component {
    render() {
        const { className, size, ...rest } = this.props;
        return (React.createElement(AvatarBase, { ...rest, className: st(classes.root, { size }, className) }));
    }
}
Avatar.displayName = 'Avatar';
Avatar.defaultProps = {
    size: AvatarSize.medium,
};
//# sourceMappingURL=Avatar.js.map